import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { providenceConfig } from "./data";

export default function ProvidencePage() {
  return <CityPageTemplate config={providenceConfig} />;
}